import { supabase } from "./supabase";

const AUDIO_BUCKET = "meetings";
const SIGNED_URL_TTL_SECONDS = 60 * 60;

export async function getAudioSignedUrl(audioPath: string): Promise<string | null> {
  const { data, error } = await supabase.storage
    .from(AUDIO_BUCKET)
    .createSignedUrl(audioPath, SIGNED_URL_TTL_SECONDS);
  if (error || !data?.signedUrl) return null;
  return data.signedUrl;
}
